import {useTranslation} from '@/translations/i18n'
import {AccessDashboardCard} from '../access-dashboard-card/AccessDashboardCard'
import {useGetAccessesDashboard} from '../../queries/useGetAccessesDashboard'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {filtersParamToPayload} from '@/utilities/helpers'
import {AccessesTableDashboardEmptyState} from '../accesses-table-dashboard/AcccessesTableDashboardEmptyState'
import {Text} from '@/components/ui/text/Text'
import {AccessesSearchParams} from '../../types'
import {AlertCircleIcon} from '@/components/ui/icon/Icon'
import {useTheme} from 'styled-components'

export const AccessesDashboardToValidateCard = () => {
    const {t} = useTranslation()
    const {searchParams} = useParsedSearchParams(AccessesSearchParams)

    const {data, isLoading} = useGetAccessesDashboard<'to_validate_accesses'>({
        payload: {
            filters: filtersParamToPayload(searchParams.filters)?.filters
        },
        params: {
            card: 'to_validate_accesses',
            startDate: searchParams.startDate,
            endDate: searchParams.endDate
        }
    })

    const {palette} = useTheme()

    if (isLoading || !data) {
        return (
            <AccessesTableDashboardEmptyState
                title={t('accesses:dashboard_accesses_to_validate')}
                isLoading={isLoading}
            />
        )
    }

    return (
        <AccessDashboardCard
            endSlot={
                !!data && data.toValidateAccesses >= 1 ? (
                    <AlertCircleIcon size={15} color={palette.danger[500]} />
                ) : null
            }
            title={t('accesses:dashboard_accesses_to_validate')}
        >
            <Text size="textLg" palette="neutral" shade="950" weight="600">
                {data ? data.toValidateAccesses : '-'}
            </Text>
        </AccessDashboardCard>
    )
}
